module.exports = __webpack_public_path__ + "img/book_mot_banner_desk.12c3f6f.webp";